import axios from "axios";
import { Cookies } from "react-cookie";

import { StaticValue } from "../seed/constants";
import { clearAuthorizationToken } from "./auth/authToken";
import { clearClaimSession, getClaimToken } from "./companies/claimSession";

const staticValue = new StaticValue();
const staticValues = staticValue.getDefaultValues();

export const API = axios.create({
	baseURL: staticValues.apiUrl,
	headers: {
		"Content-Type": "application/json",
		...staticValues.commonHeader,
	},
});

const cookies = new Cookies();
API.interceptors.request.use((config) => {
	const authToken = cookies.get("Authorization");
	const claimToken = getClaimToken();
	const isClaimTokenStoredInAuthorization = Boolean(authToken && claimToken && authToken === claimToken);

	if (config.authMode === "claim") {
		delete config.headers.Authorization;

		if (claimToken) {
			config.headers.Authorization = claimToken;
		}
	} else if (authToken && !isClaimTokenStoredInAuthorization) {
		config.headers.Authorization = authToken;
	} else if (config.headers?.Authorization) {
		delete config.headers.Authorization;
	}

	return config;
});

API.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if ([401, 403].includes(error.response?.status)) {
			if (error.config?.authMode === "claim") {
				clearClaimSession();
				window.location.href = `/signin?ref=${encodeURIComponent(
					window.location.pathname + window.location.search + window.location.hash,
				)}`;
				return Promise.reject(error);
			}

			clearAuthorizationToken();
			localStorage.removeItem("profileData");
			localStorage.removeItem("isDropzOpsUser");
			window.location.href = "/signin";
		}
		return Promise.reject(error);
	},
);
